var map = {
	"./file_Excel.png": "FX06",
	"./file_MP3.png": "30X6",
	"./file_avi.png": "4KJp",
	"./file_pdf.png": "0M0F",
	"./file_ppt.png": "lFao",
	"./file_txt.png": "D1w/",
	"./file_unknown.png": "8Xdz",
	"./file_world.png": "kkR5",
	"./file_zip.png": "vBCw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uha6";


//////////////////
// WEBPACK FOOTER
// ./packages/assets/file ^\.\/.*$
// module id = uha6
// module chunks = 1